import React, { useState } from 'react';
// Definición de categorías
const categories = [{
  id: 'mentalidad',
  name: 'Mentalidad y Propósito',
  color: 'bg-purple-500',
  emoji: '🧠'
}, {
  id: 'vivienda',
  name: 'Vivienda y Comunidad',
  color: 'bg-green-500',
  emoji: '🏡'
}, {
  id: 'finanzas',
  name: 'Finanzas y Futuro',
  color: 'bg-yellow-500',
  emoji: '💰'
}, {
  id: 'salud',
  name: 'Salud y Bienestar',
  color: 'bg-red-500',
  emoji: '❤️'
}, {
  id: 'conexion',
  name: 'Conexión y Legado',
  color: 'bg-blue-500',
  emoji: '🌍'
}];
// Ejemplo de cartas para cada categoría
const cards = {
  mentalidad: [{
    id: 1,
    title: 'Propósito diario',
    content: 'Una nueva generación de retirados vive como mentores, voluntarios y emprendedores. ¿Qué rol te inspira más? Diseña una actividad semanal que te acerque a ello.'
  }, {
    id: 2,
    title: 'Aprendizaje continuo',
    content: '¿Qué habilidad nueva te gustaría desarrollar en tu retiro? Piensa en algo que siempre quisiste aprender pero nunca tuviste tiempo.'
  }],
  vivienda: [{
    id: 1,
    title: 'Tu espacio ideal',
    content: '¿Prefieres vivir en una comunidad intergeneracional o en un lugar exclusivo para personas de tu edad? ¿Qué ventajas tendría cada opción para ti?'
  }, {
    id: 2,
    title: 'Rediseñando el hogar',
    content: 'Si pudieras adaptar tu hogar actual para tu retiro, ¿qué cambios harías para que fuera más cómodo, seguro y acogedor?'
  }],
  finanzas: [{
    id: 1,
    title: 'Inversión con impacto',
    content: '¿Considerarías reinvertir parte de tus ahorros en un emprendimiento con impacto social? ¿En qué área te gustaría contribuir?'
  }, {
    id: 2,
    title: 'Presupuesto flexible',
    content: 'Diseña un presupuesto mensual ideal para tu retiro. ¿Cuáles serían tus prioridades de gasto? ¿En qué áreas podrías ser más flexible?'
  }],
  salud: [{
    id: 1,
    title: 'Rutina de bienestar',
    content: 'Crea una rutina semanal que incluya actividad física, alimentación saludable y prácticas para tu bienestar mental. ¿Qué actividades te dan más energía?'
  }, {
    id: 2,
    title: 'Prevención activa',
    content: '¿Qué hábitos podrías incorporar ahora para mejorar tu salud en el futuro? Identifica tres cambios pequeños pero significativos.'
  }],
  conexion: [{
    id: 1,
    title: 'Tu legado personal',
    content: '¿Qué te gustaría que las futuras generaciones recordaran de ti? ¿Cómo podrías comenzar a construir ese legado desde ahora?'
  }, {
    id: 2,
    title: 'Red de apoyo',
    content: 'Identifica a las personas que formarían tu red de apoyo ideal en el retiro. ¿Qué tipo de relaciones te gustaría cultivar más?'
  }]
};
const GameBoard = () => {
  const [diceValue, setDiceValue] = useState(1);
  const [position, setPosition] = useState(0);
  const [currentCard, setCurrentCard] = useState(null);
  const [showCard, setShowCard] = useState(false);
  const [notes, setNotes] = useState('');
  // Total de casillas en el tablero
  const totalSpaces = 20;
  // Crear las casillas del tablero
  const boardSpaces = Array.from({
    length: totalSpaces
  }, (_, index) => {
    // Asignar una categoría a cada casilla
    const categoryIndex = index % categories.length;
    return {
      id: index,
      category: categories[categoryIndex]
    };
  });
  const rollDice = () => {
    const newDiceValue = Math.floor(Math.random() * 6) + 1;
    setDiceValue(newDiceValue);
    // Calcular nueva posición
    const newPosition = (position + newDiceValue) % totalSpaces;
    setPosition(newPosition);
    // Cerrar carta actual si está abierta
    setShowCard(false);
    setCurrentCard(null);
  };
  const drawCard = () => {
    const currentCategory = boardSpaces[position].category.id;
    const categoryCards = cards[currentCategory];
    const randomIndex = Math.floor(Math.random() * categoryCards.length);
    setCurrentCard(categoryCards[randomIndex]);
    setShowCard(true);
  };
  const handleNotesChange = e => {
    setNotes(e.target.value);
  };
  const closeCard = () => {
    setShowCard(false);
  };
  return <div className="w-full max-w-4xl mx-auto p-4" data-id="element-42">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-43">
        {/* Panel de juego */}
        <div className="md:col-span-2" data-id="element-44">
          <div className="bg-white rounded-xl shadow-sm p-6 mb-6" data-id="element-45">
            <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-46">
              Tablero de juego
            </h2>
            {/* Dados y controles */}
            <div className="flex items-center justify-between mb-6" data-id="element-47">
              <div className="flex items-center" data-id="element-48">
                <div className="w-16 h-16 bg-white border-2 border-gray-300 rounded-lg flex items-center justify-center text-3xl font-bold mr-4" data-id="element-49">
                  {diceValue}
                </div>
                <button onClick={rollDice} className="bg-blue-600 text-white hover:bg-blue-700 px-4 py-2 rounded-lg" data-id="element-50">
                  Lanzar dado
                </button>
              </div>
              <button onClick={drawCard} className="bg-green-600 text-white hover:bg-green-700 px-4 py-2 rounded-lg" disabled={showCard} data-id="element-51">
                Tomar carta
              </button>
            </div>
            {/* Tablero circular */}
            <div className="relative w-full aspect-square max-w-md mx-auto" data-id="element-52">
              {/* Casillas del tablero */}
              <div className="absolute inset-0 rounded-full border-4 border-gray-200 overflow-hidden" data-id="element-53">
                {boardSpaces.map((space, index) => {
                // Calcular posición en círculo
                const angle = index / totalSpaces * 2 * Math.PI;
                const radius = 45; // Porcentaje del radio
                const left = 50 + radius * Math.cos(angle - Math.PI / 2);
                const top = 50 + radius * Math.sin(angle - Math.PI / 2);
                return <div key={space.id} className={`absolute w-10 h-10 ${space.category.color} rounded-full flex items-center justify-center transform -translate-x-1/2 -translate-y-1/2 ${position === index ? 'ring-4 ring-blue-300' : ''}`} style={{
                  left: `${left}%`,
                  top: `${top}%`
                }} data-id="element-54">
                      <span className="text-lg" data-id="element-55">{space.category.emoji}</span>
                    </div>;
              })}
                {/* Centro del tablero */}
                <div className="absolute inset-0 flex items-center justify-center" data-id="element-56">
                  <div className="w-32 h-32 bg-blue-100 rounded-full flex items-center justify-center text-center p-4" data-id="element-57">
                    <div data-id="element-58">
                      <p className="font-medium text-gray-800" data-id="element-59">Tu Nueva Vida</p>
                      <p className="text-sm text-gray-600" data-id="element-60">
                        Posición: {position + 1}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Carta actual */}
          {showCard && currentCard && <div className="bg-white rounded-xl shadow-md p-6 mb-6 border-l-4 border-blue-500" data-id="element-61">
              <div className="flex justify-between items-start mb-4" data-id="element-62">
                <div data-id="element-63">
                  <h3 className="text-xl font-bold text-gray-900" data-id="element-64">
                    {currentCard.title}
                  </h3>
                  <p className="text-sm text-gray-500" data-id="element-65">
                    {categories.find(cat => cat.id === boardSpaces[position].category.id).name}
                  </p>
                </div>
                <button onClick={closeCard} className="text-gray-400 hover:text-gray-600" data-id="element-66">
                  ✕
                </button>
              </div>
              <p className="text-gray-700 mb-4" data-id="element-67">{currentCard.content}</p>
              <div className="mt-4" data-id="element-68">
                <h4 className="font-medium text-gray-900 mb-2" data-id="element-69">
                  Tus reflexiones:
                </h4>
                <textarea value={notes} onChange={handleNotesChange} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" rows={3} placeholder="Escribe tus pensamientos aquí..." data-id="element-70"></textarea>
              </div>
            </div>}
        </div>
        {/* Panel lateral */}
        <div data-id="element-71">
          <div className="bg-white rounded-xl shadow-sm p-6 mb-6" data-id="element-72">
            <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-73">Categorías</h2>
            <ul className="space-y-3" data-id="element-74">
              {categories.map(category => <li key={category.id} className="flex items-center" data-id="element-75">
                  <span className={`w-6 h-6 ${category.color} rounded-full flex items-center justify-center mr-3`} data-id="element-76">
                    <span className="text-xs" data-id="element-77">{category.emoji}</span>
                  </span>
                  <span className="text-gray-700" data-id="element-78">{category.name}</span>
                </li>)}
            </ul>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-6" data-id="element-79">
            <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-80">
              Tu progreso
            </h2>
            <div className="space-y-4" data-id="element-81">
              <div data-id="element-82">
                <p className="text-sm text-gray-600 mb-1" data-id="element-83">Cartas exploradas</p>
                <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-84">
                  <div className="bg-blue-600 h-2.5 rounded-full" style={{
                  width: '25%'
                }} data-id="element-85"></div>
                </div>
              </div>
              <div data-id="element-86">
                <p className="text-sm text-gray-600 mb-1" data-id="element-87">Decisiones tomadas</p>
                <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-88">
                  <div className="bg-green-500 h-2.5 rounded-full" style={{
                  width: '10%'
                }} data-id="element-89"></div>
                </div>
              </div>
              <div className="pt-4 mt-4 border-t border-gray-200" data-id="element-90">
                <a href="/manual" className="text-blue-600 hover:text-blue-800 text-sm font-medium" data-id="element-91">
                  Ver reglas del juego
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default GameBoard;